import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import React from 'react';

export default function SearchBar({
  searchValue,
  results,
  webSocketRef,
  setShowSkeleton,
  handleSelection,
  debounced,
  debouncedCoordinates,
  t,
  showNewLandingScreenRef,
}: {
  searchValue: string;
  results: {
    label: string;
    magicKey: string;
  }[];
  webSocketRef: React.MutableRefObject<WebSocket | null>;
  setShowSkeleton: React.Dispatch<React.SetStateAction<boolean>>;
  handleSelection: Function;
  debounced: Function;
  debouncedCoordinates: Function;
  t: Function;
  showNewLandingScreenRef?: any;
}) {
  return (
    <Autocomplete
      disablePortal
      fullWidth
      {...(showNewLandingScreenRef?.current && {
        sx: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderWidth: '1px', // normal border width
            },
            '&.Mui-focused fieldset': {
              borderWidth: '1px', // keep it 1px when focused
            },
          },
        },
      })}
      // onBlur={resetSearchComplete}

      value={searchValue}
      aria-label="search-imagery"
      autoHighlight={true}
      // clearOnBlur={true}

      blurOnSelect={true}
      freeSolo={true}
      clearIcon={
        <ClearIcon
          fontSize="small"
          onClick={() => {
            if (!webSocketRef.current) return;

            webSocketRef.current.close();
            setShowSkeleton(false);
          }}
        />
      }
      id="combo-box-demo"
      options={results}
      // getOptionLabel={(option: any) => {

      //   return option.text ? option.text : option;
      // }}
      onChange={(event, value, reason, details) => {
        // on clicking cross the value is returning null
        if (value != null) {
          //if the value is from the dropdown menu
          if (typeof value === 'object') {
            handleSelection(value);
            return;
          }
          //if the value is not from a dropdown menu and is valid coordinates
          debouncedCoordinates(value);
        }
      }}
      noOptionsText={''}
      renderOption={(props, option: any, state, ownerState) => {
        return (
          <li {...props} aria-selected={false} key={state.index}>
            {option?.label}
          </li>
        );
      }}
      renderInput={params => {
        params.inputProps['aria-label'] = 'search-text-field';
        return (
          <TextField
            {...params}
            variant={showNewLandingScreenRef?.current ? 'outlined' : 'standard'}
            placeholder={t('searchByLocation')}
            onChange={e => {
              debounced(e.target.value);
            }}
            slotProps={{
              input: {
                ...params.InputProps,
                startAdornment: (
                  <>
                    <InputAdornment position="start">
                      <SearchOutlinedIcon />
                    </InputAdornment>
                    {params.InputProps.startAdornment}
                  </>
                ),
              },
            }}
          />
        );
      }}
    />
  );
}
